<template>
    <teleport to="body">
        <div class="md:max-w-1/2 fixed right-0 top-24 z-0 justify-end">
            <div class="">
                <transition-group name="flash" :appear="true" tag="div">
                    <div
                        class="mx-12 mb-2"
                        v-for="(message, index) in messages"
                        :key="'flash_' + index"
                    >
                        <div class="ml-auto flex justify-end">
                            <div
                                :class="
                                    'message z-50 flex max-w-5xl flex-shrink items-center gap-4 rounded px-3  py-2 text-[15px] shadow' +
                                    ' ' +
                                    colors[message.type]
                                "
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    v-if="
                                        message.type === 'info' ||
                                        message.type === 'success'
                                    "
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M0.25 10C0.25 4.615 4.615 0.25 10 0.25C15.385 0.25 19.75 4.615 19.75 10C19.75 15.385 15.385 19.75 10 19.75C4.615 19.75 0.25 15.385 0.25 10ZM13.61 8.186C13.67 8.10605 13.7134 8.01492 13.7377 7.91795C13.762 7.82098 13.7666 7.72014 13.7514 7.62135C13.7361 7.52257 13.7012 7.42782 13.6489 7.3427C13.5965 7.25757 13.5276 7.18378 13.4463 7.12565C13.3649 7.06753 13.2728 7.02624 13.1753 7.00423C13.0778 6.98221 12.9769 6.97991 12.8785 6.99746C12.7801 7.01501 12.6862 7.05205 12.6023 7.10641C12.5184 7.16077 12.4462 7.23135 12.39 7.314L9.154 11.844L7.53 10.22C7.38783 10.0875 7.19978 10.0154 7.00548 10.0188C6.81118 10.0223 6.62579 10.101 6.48838 10.2384C6.35097 10.3758 6.27225 10.5612 6.26882 10.7555C6.2654 10.9498 6.33752 11.1378 6.47 11.28L8.72 13.53C8.79699 13.6069 8.8898 13.6662 8.99199 13.7036C9.09418 13.7411 9.20329 13.7559 9.31176 13.7469C9.42023 13.738 9.52546 13.7055 9.62013 13.6519C9.7148 13.5982 9.79665 13.5245 9.86 13.436L13.61 8.186Z"
                                        fill="currentColor"
                                    />
                                </svg>
                                <span v-html="message.text" />
                                <div
                                    class="ml-auto"
                                    @click="clearMessage(index)"
                                >
                                    <svg
                                        class="opacity-80 hover:cursor-pointer hover:opacity-100"
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M0.557783 0.55781C0.674971 0.440768 0.833824 0.375027 0.99945 0.375027C1.16508 0.375027 1.32393 0.440768 1.44112 0.55781L5.99945 5.11614L10.5578 0.55781C10.615 0.496404 10.684 0.447153 10.7607 0.412993C10.8373 0.378833 10.9201 0.360465 11.004 0.358984C11.0879 0.357503 11.1713 0.37294 11.2491 0.404375C11.3269 0.435809 11.3976 0.482596 11.457 0.541945C11.5163 0.601294 11.5631 0.671989 11.5946 0.749812C11.626 0.827635 11.6414 0.910993 11.6399 0.994912C11.6385 1.07883 11.6201 1.16159 11.5859 1.23826C11.5518 1.31492 11.5025 1.38393 11.4411 1.44114L6.88278 5.99948L11.4411 10.5578C11.5025 10.615 11.5518 10.684 11.5859 10.7607C11.6201 10.8374 11.6385 10.9201 11.6399 11.004C11.6414 11.088 11.626 11.1713 11.5946 11.2491C11.5631 11.327 11.5163 11.3977 11.457 11.457C11.3976 11.5164 11.3269 11.5631 11.2491 11.5946C11.1713 11.626 11.0879 11.6414 11.004 11.64C10.9201 11.6385 10.8373 11.6201 10.7607 11.586C10.684 11.5518 10.615 11.5025 10.5578 11.4411L5.99945 6.88281L1.44112 11.4411C1.32264 11.5515 1.16593 11.6116 1.00401 11.6088C0.842097 11.6059 0.687609 11.5403 0.573098 11.4258C0.458588 11.3113 0.392994 11.1568 0.390138 10.9949C0.387281 10.833 0.447383 10.6763 0.557783 10.5578L5.11612 5.99948L0.557783 1.44114C0.440741 1.32396 0.375 1.1651 0.375 0.999477C0.375 0.833851 0.440741 0.674998 0.557783 0.55781Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </div>
        </div>
    </teleport>
</template>

<script>
export default {
    name: "FlashMessages",
    data() {
        return {
            messages: [],
            colors: {
                info: "bg-black text-white",
                success: "bg-green-400 text-white",
                error: "bg-red-500  text-white",
            },
        };
    },
    methods: {
        clearMessage(message) {
            this.messages.splice(this.messages.indexOf(message), 1);
        },
        showAlerts() {
            let vm = this;
            let messages = [];

            if (vm.$page.props.flash.success) {
                if (typeof vm.$page.props.flash.success === "string") {
                    messages.push({
                        type: "success",
                        text: vm.$page.props.flash.success,
                        timeout: 5,
                    });
                } else {
                    vm.$page.props.flash.success.forEach(function (item) {
                        messages.push({
                            type: "success",
                            text: item.message,
                            timeout: item.timeout,
                        });
                    });
                }
            }

            if (vm.$page.props.flash.error) {
                if (typeof vm.$page.props.flash.error === "string") {
                    messages.push({
                        type: "error",
                        text: vm.$page.props.flash.error,
                        timeout: 20,
                    });
                } else {
                    vm.$page.props.flash.error.forEach(function (item) {
                        messages.push({
                            type: "error",
                            text: item.message,
                            timeout: item.timeout,
                        });
                    });
                }
            }

            if (vm.$page.props.flash.info) {
                if (typeof vm.$page.props.flash.info === "string") {
                    messages.push({
                        type: "info",
                        text: vm.$page.props.flash.info,
                        timeout: 5,
                    });
                } else {
                    vm.$page.props.flash.info.forEach(function (item) {
                        messages.push({
                            type: "info",
                            text: item.message,
                            timeout: item.timeout,
                        });
                    });
                }
            }

            vm.messages = messages;

            vm.messages.forEach(function (item, index) {
                item.index = index;
                if (item.timeout !== 0) {
                    setTimeout(function () {
                        if (item.type === "success" || item.type === "info") {
                            vm.clearMessage(item.index);
                        }
                    }, item.timeout * 1000 + 250 * index);
                }
            });
        },
    },
    mounted() {
        this.showAlerts();
    },
    watch: {
        "$page.props.flash": {
            handler(newValue, oldValue) {
                this.showAlerts();
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.flash-move,
.flash-enter-active,
.flash-leave-active {
    transition: all 0.75s;
}

.flash-enter-from,
.flash-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}
</style>
